import { combineReducers } from "redux";
import { arrangemang } from "../reducers/arrangemang";
import { signering } from "../reducers/signering";
import { ovrigt } from "../reducers/reducers";
import { user } from "../reducers/user";
import { kulturprogram } from "./kulturprogram";

const rootReducer = combineReducers({
  kulturprogram,
  arrangemang,
  signering,
  ovrigt,
  user,
});

export default rootReducer;
